/* this file is transformed by vux-loader */
/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import plugins from './plugins/plugins'; // 全局通用

import globalStore from './modules/globalStore';
import appStore from './modules/appStore';
import global from './modules/global';
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    appStore: appStore,
    globalStore: globalStore,
    global: global
  },
  plugins: plugins,
  scrict: process.env.NODE_ENV !== 'production'
});